// @flow
import SearchResultItem from './SearchResultItem';

export default SearchResultItem;



// WEBPACK FOOTER //
// ./src/components/search/SearchResultItem/index.js